import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import IsMobileContext from "../contexts/is-mobile-context";

const RespondTo = ({ className, children, component: Component, ...props }) => {
  const isMobile = React.useContext(IsMobileContext);

  if (Component) {
    return <Component children={children} className={classNames(className, { "is-mobile": isMobile })} {...props} />;
  }
  return (
    <div className={classNames(className, { "is-mobile": isMobile })} {...props}>
      {children}
    </div>
  );
};

RespondTo.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  children: PropTypes.any,
  component: PropTypes.any,
};

export default RespondTo;
